import './MessageContent.scss';
import { prefixClass } from 'lib/utils';
import { formatMessageContentToHtml, FormatMessageContentOptions } from './formatMessageContent';
import { analyzeMessageContent, AnalyzeMessageContentOptions, MessageDetailsContent } from './analyzeMessageContent';
import MessagePreviewModule from './subcomponents/MessagePreviewModule/MessagePreviewModule';
import { Attachment } from '../../../../../Queue/Chat/Chat';
import type { CheckListItemProps } from '../../../../Common/CheckList/CheckList';
import type { AskRequest } from '@hone-automation/common';

import type { EmailMetadata } from './analyzeMessageContent';

interface MessageContentProps extends FormatMessageContentOptions {
  message: string;
  attachments?: Attachment[];
  checklist?: CheckListItemProps[];
  details?: MessageDetailsContent;
  emailMetadata?: EmailMetadata;
  isFirstMessage?: boolean;
  request?: AskRequest;
}

const MessageContent = ({
  message,
  users,
  fallbackUser,
  skipMentionFormatting,
  attachments,
  checklist,
  details,
  emailMetadata,
  isFirstMessage,
  request,
}: MessageContentProps) => {
  const prefix = prefixClass('q2-message-content');
  const analyzeOptions: AnalyzeMessageContentOptions = {
    attachments,
    checklist,
    details,
    emailMetadata,
    isFirstMessage,
    request,
    formatting: { users, fallbackUser },
  };
  const { extras, remainingMessage } = analyzeMessageContent(message, analyzeOptions);
  const parsedContent = formatMessageContentToHtml(remainingMessage, { users, fallbackUser, skipMentionFormatting });

  return (
    <>
      {parsedContent && <div className={prefix()} dangerouslySetInnerHTML={{ __html: parsedContent }} />}
      {extras.length > 0 && <MessagePreviewModule extras={extras} />}
    </>
  );
};

export default MessageContent;
